<template>
  <div class="v2-page">
    <div class="v2-operations">
      <template v-if="isLoaded">
        <h2 class="v2-heading-sm v2-operations__title">
          Operations &amp; Trade
        </h2>

        <v2-segmentation-section
          v-if="segmentation.isBrand.value"
          :segmentation="segmentation"
          :segmentation-data="originalSegmentationData"
        />

        <hr
          v-if="segmentation.isBrand.value"
          class="v2-operations__divider"
        >

        <v2-address-section
          :addresses="addresses"
          :countries="countriesList"
        />
      </template>

      <div
        v-else
        class="v2-operations__loading"
      >
        <v2-spinner
          size="lg"
          label="Loading operations data..."
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { useOperations } from '@/composables/useOperations'
import V2Spinner from '@/components/v2/V2Spinner.vue'
import V2SegmentationSection from './V2SegmentationSection.vue'
import V2AddressSection from './V2AddressSection.vue'

export default {
  name: 'V2Operations',
  components: {
    V2Spinner,
    V2SegmentationSection,
    V2AddressSection,
  },
  setup() {
    const {
      isLoaded,
      countries,
      originalSegmentationData,
      segmentation,
      addresses,
      fetchOperationsData,
    } = useOperations()

    fetchOperationsData()

    const countriesList = computed(() => countries.value)

    return {
      isLoaded,
      segmentation,
      addresses,
      originalSegmentationData,
      countriesList,
    }
  },
}
</script>

<style lang="scss" scoped>
.v2-page {
  min-height: 100%;
}

.v2-operations {
  max-width: 960px;
  margin: 0 auto;

  &__title {
    margin-bottom: var(--v2-space-5);
  }

  &__divider {
    border: none;
    border-top: 1px solid var(--v2-border);
    margin: var(--v2-space-6) 0;
  }

  &__loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;
  }
}
</style>
